<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[50px]">
  <ng-container *ngIf="step === 1">
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-vrbo-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_vrbo_html_标题" | translate }}
      <!-- Connect with Vrbo -->
    </div>

    <div class="text-m mt-[30px]">
      {{ "channel-connect_vrbo_html_说明" | translate }}
      <!-- Hostex requires a login token to access your Vrbo account API. Your token will be stored encrypted. If you change
      your password which will cause the token to become invalid, you will need to reconnect. -->
    </div>

    <div class="v4-layout-form mt-[30px]" [formGroup]="form">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel.vrbo.link.step1.placeholder_1' | translate"
            formControlName="username" />
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel.vrbo.link.step1.placeholder_2' | translate"
            formControlName="password" />
        </div>
      </div>
    </div>

    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>
      <button
        [class]="footerConfirmBtnClass"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="loading"
        (click)="onClickCreate()">
        {{ "channel-connect_vrbo_html_连接" | translate }}
        <!-- Connect -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 2">
    <div class="text-l font-bold">
      {{ "channel.vrbo.link.step2.title" | translate }}
      <!-- Two-factor authentication -->
    </div>

    <div class="text-m mt-[30px]">
      {{ "channel-connect_vrbo_html_需要两步验证" | translate }}
      <!-- Vrbo requires a two-factor authentication, please select the authentication method. -->
    </div>

    <div class="v4-layout-form mt-[30px]">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <button nz-button nzBlock nzSize="large" (click)="onClickVerifyType('sms')">
            {{ "channel.vrbo.link.step2.verify_btn_1" | translate }}
            <!-- Send me an SMS -->
          </button>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <button nz-button nzBlock nzSize="large" (click)="onClickVerifyType('call')">
            {{ "channel.vrbo.link.step2.verify_btn_2" | translate }}
            <!-- Call me -->
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 3">
    <div class="text-l font-bold">
      {{ "channel.vrbo.link.step2.title" | translate }}
      <!-- Two-factor authentication -->
    </div>

    <div class="text-m mt-[30px]">
      {{ "channel.vrbo.link.step3.title" | translate }}
      <!-- Enter the verification code -->
    </div>

    <div class="v4-layout-form mt-[30px]" [formGroup]="verifyForm">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel.vrbo.link.step3.placeholder' | translate"
            formControlName="code" />
        </div>
      </div>
    </div>

    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button [class]="footerConfirmBtnClass" nz-button nzType="primary" nzSize="large" (click)="onClickSubmitCode()">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </ng-container>

  <!-- @if (step === 4) {
    <host-set-pricing-ratio (onBack)="step = 3" (onNext)="onFinish()"></host-set-pricing-ratio>
  } -->
</div>
